import { render, staticRenderFns } from "./SLRData.vue?vue&type=template&id=c0f0826a&scoped=true&"
import script from "./SLRData.vue?vue&type=script&lang=ts&"
export * from "./SLRData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f0826a",
  null
  
)

export default component.exports